const generateSkeletonData = <Key, RecordType>(
  keys: Key[],
  rows = 20
): RecordType[] => {
  return Array.from(Array(rows).keys()).map((_, idx) =>
    keys.reduce(
      (acc, cur, keyIdx) =>
        ({
          ...acc,
          [`${cur}`]: '~',
          ...(keyIdx + 1 === keys.length
            ? {
                key: idx
              }
            : {})
        }) as RecordType,
      {} as RecordType
    )
  )
}

export default generateSkeletonData
